var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconNext = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_back")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_Overview",
    transform: "translate(-702.000000, -1249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(45.000000, 642.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_back",
    transform: "translate(665.000000, 615.000000) scale(-1, 1) translate(-665.000000, -615.000000) translate(657.000000, 607.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,0 L10.6666667,0 C13.6121853,-5.41083001e-16 16,2.38781467 16,5.33333333 L16,10.6666667 C16,13.6121853 13.6121853,16 10.6666667,16 L5.33333333,16 C2.38781467,16 3.60722001e-16,13.6121853 0,10.6666667 L0,5.33333333 C-3.60722001e-16,2.38781467 2.38781467,5.41083001e-16 5.33333333,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(0.117554, 0.170796)",
    fill: "#38DCBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.63412298,6.72925985 L14.4342352,6.72925985 C15.0417174,6.72925985 15.5341791,7.2217215 15.5341791,7.82920373 C15.5341791,8.43668597 15.0417174,8.92914762 14.4342352,8.92914762 L1.63412298,8.92914762 C1.02664074,8.92914762 0.534179094,8.43668597 0.534179094,7.82920373 C0.534179094,7.2217215 1.02664074,6.72925985 1.63412298,6.72925985 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(8.034179, 7.829204) rotate(-360.000000) translate(-8.034179, -7.829204) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.266808956,3.56692119 L9.06692119,3.56692119 C9.67440342,3.56692119 10.1668651,4.05938284 10.1668651,4.66686507 C10.1668651,5.27434731 9.67440342,5.76680896 9.06692119,5.76680896 L0.266808956,5.76680896 C-0.340673275,5.76680896 -0.833134926,5.27434731 -0.833134926,4.66686507 C-0.833134926,4.05938284 -0.340673275,3.56692119 0.266808956,3.56692119 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(4.666865, 4.666865) rotate(-45.000000) translate(-4.666865, -4.666865) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.266808956,9.89159851 L9.06692119,9.89159851 C9.67440342,9.89159851 10.1668651,10.3840602 10.1668651,10.9915424 C10.1668651,11.5990246 9.67440342,12.0914863 9.06692119,12.0914863 L0.266808956,12.0914863 C-0.340673275,12.0914863 -0.833134926,11.5990246 -0.833134926,10.9915424 C-0.833134926,10.3840602 -0.340673275,9.89159851 0.266808956,9.89159851 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(4.666865, 10.991542) scale(1, -1) rotate(-45.000000) translate(-4.666865, -10.991542) "
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNext, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_next.2005f3c0.svg";
export { ForwardRef as ReactComponent };